import { useState } from "react";
import { useApi } from "../../../api";
import { Button } from "../../../elements";
import { downloadFile } from "../../../utils";

interface Props {
  merchflowId: number;
  s2SolutionId: number;
}

export const S2LogsButton = ({ merchflowId, s2SolutionId }: Props) => {
  const { getMerchflowS2LogsApi } = useApi();

  // Loading with state, because all stores page has many logs buttons, need to show spinner only for the one button.
  const [isLoading, setIsLoading] = useState(false);

  const downloadLogs = async () => {
    setIsLoading(true);
    const response = await getMerchflowS2LogsApi(merchflowId, s2SolutionId);
    if (response) {
      downloadFile({
        name: `s2_logs_${merchflowId}_${s2SolutionId}`,
        extension: "json",
        data: JSON.stringify(response),
      });
    }
    setIsLoading(false);
  };

  return (
    <Button color="greenSmoke" variant="inverted" onClick={downloadLogs} isLoading={isLoading}>
      {"Logs"}
    </Button>
  );
};
